import Stack from '@careguide/stack'
import { Heading } from '@careguide/typography'

import { Recommender } from 'types/recommendations'
import Recommendation from './Recommendation'

type RecommendationsProps = {
  recommenders: Array<Recommender>
  listingOwnerName: string
  siteKeyword: string
}

const Recommendations = ({ recommenders, listingOwnerName, siteKeyword }: RecommendationsProps) => {
  if (!recommenders || recommenders.length === 0) {
    return null
  }

  return (
    <Stack gap='2'>
      <Heading as='h2'>Recommendations</Heading>
      <Stack gap='4' role='list'>
        {recommenders.map((recommender, index) => (
          <Recommendation
            recommender={recommender}
            listingOwnerName={listingOwnerName}
            siteKeyword={siteKeyword}
            key={index}
          />
        ))}
      </Stack>
    </Stack>
  )
}

export default Recommendations
